module.exports = __webpack_public_path__ + "static/historical-scheme-light-be95cfb36e672727ec2d99b009e9d92c.png";